
import { defineComponent, ref, onMounted, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import router from "@/router";
import UnusedStocks, {
  exportUnusedStockData,
  exportPDFUnusedStocks,
} from "@/core/data/unusedStock";
import { UnusedStock, getUnusedStocks, deleteUnusedStock } from "@/core/data/unusedStock";
import moment from "moment";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getUserById, getUsers } from "@/core/data/users";
import { getError } from "@/core/helpers/utils";

export default defineComponent({
  name: "UnusedStock-listing",
  components: {
    Datatable,
  },
  setup() {
    const checkedUnusedStock = ref([]);
    const selectedStatus = ref("");

    let selectedItem = ref({});
    let selectedUser = ref();

    const total = ref<any>(0);
    const currentPage = ref<any>(1);
    const showSearchPanel = ref<boolean>(true);
    const selectAllUnusedStock = ref<boolean>(false);
    const isLoading = ref<boolean>(true);
    const search = ref<string>("");
    const tableData = ref<Array<UnusedStock>>(UnusedStocks);
    const userList = ref<any>({});
    const searchData = ref<any>({});
    const userOptionList = ref<any>([]);
    const userIdList = ref<Array<any>>([]);
    const branch = ref([]);
    const course = ref([]);
    const universiteies = ref([]);
    const getListItems = function (pageNumber) {
      console.log("selectedUser.value", selectedUser.value);
      isLoading.value = true;
      if (pageNumber) {
        currentPage.value = pageNumber;
      }
      return new Promise((res, rej) => {
        getUnusedStocks(
          currentPage.value,
          searchData.value,
          selectedStatus.value,
          selectedUser.value
        ).then((resObj: any) => {
          isLoading.value = false;
          total.value = resObj.count;
          tableData.value.splice(0, tableData.value.length, ...resObj.data);
          console.log("tableData", tableData.value);
          let promiseList: any = [];
          tableData.value.forEach((item) => {
            if (userIdList.value.indexOf(item.created_by) == -1) {
              userIdList.value.push(item.created_by);
              promiseList.push(getUserName(item.created_by));
            }
            Promise.all(promiseList).then(() => {
              res(resObj);
            });
          });
          console.log("tableData", tableData.value);
        });
      });
    };
    const getDropdownOptions = function(){
      console.log("Dropdon options are called")
    }
    const getUserName = async function (id) {
      if (!userList.value[id]) {
        let userData = await getUserById(id);
        userList.value[id] = userData;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("UnusedStocks Listing", ["Apps", "UnusedStocks"]);
      getListItems(1);
      getDropdownOptions()
    });

    const userListComputed = computed(() => {
      return [
        { id: "", name: "All" },
        ...userOptionList.value.map((item) => ({
          name: item.name,
          ...item,
        })),
      ];
    });

    const asyncUser = (query) => {
      console.log("query", query);
      getUsers(1, query).then((resObj: any) => {
        userOptionList.value.splice(
          0,
          userOptionList.value.length,
          ...resObj.data
        );
      });
    };
    const deleteFewSites = () => {
      checkedUnusedStock.value.forEach((item) => {
        deleteUnusedStock(item);
      });
      checkedUnusedStock.value.length = 0;
    };
    const exportFewSites = () => {
      exportUnusedStockData(
        selectAllUnusedStock.value ? "all" : checkedUnusedStock.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your UnusedStock has been exported.", "success");
      });
    };
    const exportPDFUnusedStocksHanlder = () => {
      exportPDFUnusedStocks(
        selectAllUnusedStock.value ? "all" : checkedUnusedStock.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your UnusedStock has been exported.", "success");
      });
    };
    const deleteUnusedStockItem = (item) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteUnusedStock(item)
            .then(() => {
              Swal.fire(
                "Deleted!",
                "Your UnusedStock has been deleted.",
                "success"
              );
              getListItems(currentPage.value);
            })
            .catch((err) => {
              Swal.fire({
                html: getError(err),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };
    const searchItems = () => {
      getListItems(1);
    };

    const setSelectedItem = (item) => {
      selectedItem.value = item;
    };

    const addUnusedStock = (id) => {
      if (id) {
        router.push({ name: "apps-edit-unused-stock", params: { id: id } });
      } else {
        router.push({ name: "apps-add-unused-stock" });
      }
    };
    const stockUnusedStockItem = (id) => {
      router.push({ name: "apps-stock-unused-stock", params: { id: id } });
    };
    const onPageChange = (pageNumber) => {
      return getListItems(pageNumber);
    };

    const userData = computed(() => {
      return store.getters.currentUser;
    });
    const hasCreate = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasEdit = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const hasDelete = computed(() => {
      return ["ADMIN"].indexOf(userData.value.role) > -1;
    });
    const tableHeader = computed(() => {
      let columnsArr = [
        {
          name: " ",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "Quantity",
          key: "qty",
          sortable: false,
        },
        {
          name: "Remark",
          key: "remark",
          sortable: false,
        },
        {
          name: "Type",
          key: "type",
          sortable: false,
        },
        {
          name: "Design",
          key: "design",
          sortable: false,
        },
        {
          name: "Material",
          key: "material",
          sortable: false,
        },
      ];
      if (hasEdit.value || hasDelete.value) {
        columnsArr.push({
          name: "Actions",
          key: "actions",
          sortable: false,
        });
      }
      return columnsArr;
    });
    return {
      addUnusedStock,
      setSelectedItem,
      selectedItem,
      tableData,
      tableHeader,
      deleteUnusedStock,
      getUnusedStocks,
      deleteUnusedStockItem,
      search,
      searchItems,
      checkedUnusedStock,
      deleteFewSites,
      moment,
      total,
      currentPage,
      isLoading,
      onPageChange,
      userData,
      hasCreate,
      hasEdit,
      hasDelete,
      selectedStatus,
      getUserName,
      userList,
      userListComputed,
      selectedUser,
      asyncUser,
      exportFewSites,
      exportPDFUnusedStocksHanlder,
      selectAllUnusedStock,
      showSearchPanel,
      searchData,
      branch,
      universiteies,
      course,
      stockUnusedStockItem,
    };
  },
});
